import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowSplitDown"><Path d="M7.03027 18.0303L5.03027 20.0303L3.96973 18.9697L5.96973 16.9697L7.03027 18.0303Z" fill="currentColor"/><Path d="M12.75 11.6895L18.5 17.4395V13H20V20H13V18.5H17.4395L11.25 12.3105V3H12.75V11.6895Z" fill="currentColor"/><Path d="M10.5303 14.5303L8.53027 16.5303L7.46973 15.4697L9.46973 13.4697L10.5303 14.5303Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitDown;
